import { Grid } from "@mui/material";
import { ItemTypeCheckbox } from "components/FormControls/ItemTypeCheckbox";
import { useMessage } from "hooks/intl";
import {
  AchievementTriggers,
  AchievementTriggersUnion,
} from "types/achievements";
import { CustomEvent } from "./CustomEvent";

interface Props {
  trigger: AchievementTriggersUnion;
  setFieldValue: (field: string, value: any) => void;
  activeRule: number;
  event?: string;
  errors: any;
}

export const RuleTrigger = ({
  trigger,
  setFieldValue,
  activeRule,
  event,
  errors,
}: Props) => {
  const { message } = useMessage();

  return (
    <Grid container spacing={12}>
      <Grid item xs={6}>
        <ItemTypeCheckbox
          activeItem={trigger === AchievementTriggers.TRANSACTION}
          data-test-id={`rule-${activeRule}-trigger-transaction`}
          label={message({ id: "transaction" })}
          description={message({
            id: "purchaseTransactionSuccessfullyMatchedWithMember",
          })}
          onClick={() => {
            setFieldValue(`rules[${activeRule}].trigger`, "transaction");
            setFieldValue(`rules[${activeRule}].event`, undefined);
            setFieldValue(`rules[${activeRule}].conditions`, []);
            setFieldValue(`rules[${activeRule}].aggregation.type`, "quantity");
            setFieldValue(
              `rules[${activeRule}].completeRule.onlyUniqueAttributeValues`,
              undefined,
            );
            setFieldValue(
              `rules[${activeRule}].completeRule.uniqueAttribute`,
              undefined,
            );
          }}
        />
      </Grid>
      <Grid item xs={6}>
        <ItemTypeCheckbox
          activeItem={trigger === AchievementTriggers.CUSTOM_EVENT}
          data-test-id={`rule-${activeRule}-trigger-custom-event`}
          label={message({ id: "customEvent" })}
          description={message({
            id: "eventSourcedFromExternalSystemOrApp",
          })}
          onClick={() => {
            setFieldValue(`rules[${activeRule}].trigger`, "custom_event");
            setFieldValue(`rules[${activeRule}].conditions`, []);
            setFieldValue(`rules[${activeRule}].aggregation.type`, "quantity");
            setFieldValue(
              `rules[${activeRule}].completeRule.onlyUniqueAttributeValues`,
              undefined,
            );
            setFieldValue(
              `rules[${activeRule}].completeRule.uniqueAttribute`,
              undefined,
            );
          }}
        />
      </Grid>
      {trigger === AchievementTriggers.CUSTOM_EVENT && (
        <Grid item xs={12}>
          <CustomEvent
            activeRule={activeRule}
            event={event}
            isFullWidth={true}
            setFieldValue={setFieldValue}
            error={errors?.event}
          />
        </Grid>
      )}
    </Grid>
  );
};
